import ReportDataProcessor from "./ReportDataProcessor"
import Exclusions from "./exclusions"
import Licenses from "./licenses"
import Badges from "./badges"
import {encode} from "./lib-common";

import reportJson from "./reportjson"

export default class Reports{
    constructor(headers){
        this.headers=headers;

        this.exclusions=new Exclusions(headers);
        this.licenses = new Licenses(headers);
        this.badges = new Badges(headers);

    }
    async get(pid,reportUUID){
        try{
            const reportRequest= await fetch(`/api/v1/reports/${pid}/full/${reportUUID}?includes=prs&slug=${Date.now()}`,{headers:this.headers})
            if(reportRequest.status!==200) throw await reportRequest.json()
            const report= await reportRequest.json();
            return report;
        }
        catch(e){
            throw e
        }
    }
    async getByPid(pid, branch){
        if(!branch || !branch.length) throw new Error("NOT FOUND")
        // return reportJson
        try{
            const reportRequest= await fetch(`/api/v1/reports/${pid}/full?includes=prs&branch=${window.cleanEncodeURIComponent(branch)}&slug=${Date.now()}`,{headers:this.headers})
            if(reportRequest.status!==200) throw await reportRequest.json()
            const report= await reportRequest.json();
            return report;
        }
        catch(e){
            throw e
            // if(e.status===404)
            //     return {report:{status:"NOT FOUND"}, reportReady: true, errorReport: true};
            // else
            //     return {report:{}, reportReady: true, errorReport: false};
        }
    }


    process(report, exclusions, exclusionsInReport){
        const processor = new ReportDataProcessor(report, exclusions, exclusionsInReport)
        return processor.process()
    }

    reportError(e){
        return{
            errorReport: true,
            report:{status:"NOT FOUND"},
            reportReady: true,
            reason: e
        }
    }

    
    async recompute(pid,branch, partial){
        try{
            let requestUrl = `/api/v1/reports/${pid}/full?branch=${window.cleanEncodeURIComponent(branch)}`
            if(partial) requestUrl+="&includes=security"
            const recomputeRequest= await fetch(requestUrl,{
                method: 'POST',
                headers: this.headers
            })
            if(recomputeRequest.status!==200) throw await recomputeRequest.json();
            const report= await recomputeRequest.json();
            return this.preprocess(report);
        }
        catch(e){
            throw e
        }
    }

    async refresh(uuid,branch){
        try{
            const refreshRequest = await fetch(`/api/v1/pull-server/projects/${uuid}?branch=${window.cleanEncodeURIComponent(branch)}`,{
                method: 'POST',
                headers: this.headers,
            })
            if(refreshRequest.status!==200) throw new Error();
            return true
        }
        catch(e){
            return false
        }
    }

    preprocess(report, exclusions){
        const rawReport = JSON.parse(JSON.stringify(report))
        const currentExclusionsMap = this.exclusions.map(report.exclusions)
        const exclusionsMap = this.exclusions.map(exclusions);
        const processed = this.process(report, exclusionsMap, currentExclusionsMap)

        const summary = this.generateReportSummary(report)
        summary.security = processed.security.summary
        summary.licensing = processed.licensing.summary
        this.recountLicensingVulnerabilities(report);
        report.areExclusionsDifferent = processed.areExclusionsDifferent
        return {
            security: processed.security, 
            licensing: processed.licensing,
            report, 
            summary,
            uuid: report.uuid,
            rawReport
        }

    }

    async generateDownloadContent(subject, pid,branch){
        try{
            const request = await fetch(`/api/v1/reports/${pid}/${subject}?branch=${window.cleanEncodeURIComponent(branch)}`,{
                method: "POST",
                headers: this.headers
            })
            if(request.status!==200) throw new Error()
            return await request.text()
        }
        catch(e){
            return null
        }
    }



    generateReportSummary(report){

        const stabilitySummary = (stability) =>{
            const summary = {
                byLanguage: {}
            }
            for( const report of stability.reports){
                const {language,componentsCount} = report;
                if(!summary.byLanguage[language]){
                    summary.byLanguage[language]={minor:0,major:0,patch:0,exclusions:0,components: !isNaN(componentsCount)?componentsCount:null}
                }
                for(const version of report.versions){
                    const hasExclusions = !!version.exclusions && version.exclusions.length > 0;
                    if(hasExclusions) {
                        summary.byLanguage[language].exclusions++; continue
                    }
                    if(version.newPatchVersionAvailable){
                        summary.byLanguage[language].patch++; continue;
                    }
                    if(version.newMinorVersionAvailable){
                        summary.byLanguage[language].minor++; continue;
                    }
                    if(version.newMajorVersionAvailable){
                        summary.byLanguage[language].major++; continue;
                    }
                }
            }
            return summary
        }

        const licensingSummary = (licensing)=>{
            const summary = {
                byLanguage: {}
            }
            for( const report of licensing.reports){
                const {componentsCount,language} = report;
                if(!summary.byLanguage[language]){
                    summary.byLanguage[language]={tot:0,undeclared:0,forbidden:0,violationExclusions:0,warningExclusions:0, components: !isNaN(componentsCount)?componentsCount:null}
                }
                summary.byLanguage[language].tot=report.results.length;
                for(const result of report.results){
                    if(result.violations.length){
                        summary.byLanguage[language].forbidden++;
                    }
                    if(result.warnings.length){
                        summary.byLanguage[language].undeclared++;
                    }
                    
                }
                for(const result of report.results){
                    const hasExclusions = !!result.exclusions && result.exclusions.length > 0;
                    if(!hasExclusions) continue;
                    if(result.warnings.length)
                        summary.byLanguage[language].warningExclusions++;
                    if(result.violations.length)
                    summary.byLanguage[language].violationExclusions++;
                }
            }
            return summary
        }

        let summary = {}
        const {stability,licensing} = report;

        summary.stability = stabilitySummary(stability);
        summary.licensing = licensingSummary(licensing);

        
        return summary
    }

    //this should have been fixed on backend.. to doublecheck
    recountLicensingVulnerabilities(report){
		const total=report.licensing.reports.reduce((tot,report)=>{
			const partial=report.results.reduce((acc,result)=>{
				acc.violations+=result.violations.length;
				acc.warnings+=result.warnings.length;
				return acc;
			},{violations:0, warnings:0})
			report.warningsCount=partial.warnings;
			report.violationsCount=partial.violations;
			tot.violations+=partial.violations;
			tot.warnings+=partial.warnings;
			return tot;
		},{violations:0,warnings:0})
		report.licensing.warningsCount=total.warnings;
		report.licensing.violationsCount=total.violations;
    }
}






